<template>
    <div id="app">
        <headers v-if="headersShow"></headers>
        <div class="scrollbar_style" :class="{'padding':headersShow}">
            <side-bar v-show="sideBarShow"></side-bar>
            <router-view></router-view>
        </div>
    </div>
</template>

<script type="text/javascript">
    Date.prototype.format = function(fmt) { 
        let ret;
        const opt = {
            "Y+": this.getFullYear().toString(),        // 年
            "m+": (this.getMonth() + 1).toString(),     // 月
            "d+": this.getDate().toString(),            // 日
            "H+": this.getHours().toString(),           // 时
            "M+": this.getMinutes().toString(),         // 分
            "S+": this.getSeconds().toString()          // 秒
            // 有其他格式化字符需求可以继续添加，必须转化成字符串
        };
        for (let k in opt) {
            ret = new RegExp("(" + k + ")").exec(fmt);
            if (ret) {
                fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
            }
        }
        return fmt; 
    }
    
    import headers from './components/header.vue'
    import allUrl from './api/allUrl.js'
    // import base from './api/base.js'
    import { mapGetters } from 'vuex'
    import sideBar from './components/sideBar.vue'
    // import $ from  'jquery'
    // import mCustomScrollbar from './api/jquery.mCustomScrollbar.concat.min.js'

    export default {
        name:'App',
        data(){
            return{
                headersShow:false,
                i18nArr:['zh-CN','en-US'],
                linkTypeData:{}
                // webapiAmap:false,
                // isGoogleapis:false,
            }
        },
        computed:{
            ...mapGetters({
                version:'version',
                routerStr:'routerStr',
                remRatio:'remRatio',
                sideBarShow:'sideBarShow',
                updateRemRatio:'updateRemRatio',

                isGoogleapis:'isGoogleapis',
                webapiAmap:'webapiAmap',
            }),
        },
        components:{
            'headers':headers,
            'sideBar':sideBar
        },
        beforeCreate(){
        },
        created(){
            var storage = window.localStorage;
            let data;
            let url = window.location.href.split("/")[2];
            let protocolStr = document.location.protocol;
            let subStrW = protocolStr=='https:'?'wss:':'ws:';
            let subStrT = new RegExp('https:');//创建正则表达式对象
            let street;
            if(url == 'localhost:8080' || url == '127.0.0.1:8080'){
                street = 'room.lampmind.com';
                // street = 'www.iotena-web.com';
                protocolStr = 'https:'
                // subStrW = 'wss:'
                // street = '120.77.179.55';

                this.$store.commit('DOMAINNAME',{
                  domainName:'lighting',
                })
                data = {token:"27cc9eaa89c63c65df47901692a70bc7",username:"admin",id:"1",role:1,number:"123456789",avatar:"https://room.lampmind.com/upload/image/494c7d9250d2e9314fe6025accc87d8b.jpg",lastLoginTime:"2020-03-27 09:58:21",client_key:"23be0e4c9a2e91b330bfeb7d20229e71",version:"1"}
                
                // data = {token:"9e7a6e106700edab6102740ea89eb7c7",username:"plm",id:"5",role:2,number:"7562",avatar:"https://www.iotena-web.com/upload/image/38b52a002f87569ceddb8e0b62436a04.jpg",lastLoginTime:"2020-03-26 17:20:30",client_key:"23be0e4c9a2e91b330bfeb7d20229e71",version:"0"}
                storage.setItem('userData',JSON.stringify(data))
                // street = '120.77.179.55';
                // this.versionFun('0')
                // this.$store.commit('DOMAINNAME',{
                //     domainName:'elinker',
                // })
            }else{
                street = url;
                if(url == 'room.lampmind.com'){
                    this.$store.commit('VERSION',{
                      version:'1',
                    })
                    this.$store.commit('DOMAINNAME',{
                      domainName:'room',
                    })
                }
                if(url == 'elinker.lampmind.com'){
                    /*域名和logo*/
                    this.$store.commit('VERSION',{
                      version:'1',
                    })
                    this.$store.commit('DOMAINNAME',{
                      domainName:'elinker',
                    })
                }
                if(url == 'uvlight.lampmind.com'){
                    this.$store.commit('VERSION',{
                      version:'1',
                    })
                    this.$store.commit('DOMAINNAME',{
                      domainName:'uvlight',
                    })
                }
                if(url == 'raycono.triliros.lampmind.com'){
                    this.$store.commit('VERSION',{
                      version:'0',
                    })
                    this.$store.commit('DOMAINNAME',{
                      domainName:'uvlight',
                    })
                }
                if(url == 'rayconotriliros.lampmind.com'){
                    this.$store.commit('VERSION',{
                      version:'1',
                    })
                    this.$store.commit('DOMAINNAME',{
                      domainName:'uvlight',
                    })
                }
                if(url == 'lighting.lampmind.com'){
                    this.$store.commit('VERSION',{
                      version:'1',
                    })
                    this.$store.commit('DOMAINNAME',{
                      domainName:'lighting',
                    })
                }

            }
            for(let i in allUrl){
                for(let key in allUrl[i]){
                    if(i == 'websocket'){
                        allUrl[i][key]=allUrl[i][key].replace(new RegExp('ws:'),subStrW);
                        allUrl[i][key]=allUrl[i][key].replace(new RegExp('www.iotena-web.com'),street);
                    }else{
                        allUrl[i][key]=allUrl[i][key].replace(subStrT,protocolStr);
                        allUrl[i][key]=allUrl[i][key].replace(new RegExp('www.inhealth.iotena.com'),street);
                    }
                }
            }
            
            let linkTypeArr =  window.location.href.split("/");
            let linkType = linkTypeArr[linkTypeArr.length-1].split("?")[0];
            if(storage.getItem('userData')){
                data = JSON.parse(storage.getItem('userData'))
                console.log(data)
                this.$store.commit('USERDATAFUN',{
                    username:data.username,
                    id:data.id,
                    role:data.role,
                    lastLoginTime:data.lastLoginTime,
                    client_key:data.client_key,
                    token:data.token,
                    number:data.number,
                    avatar:data.avatar,
                    version:data.version,
                })
                // this.versionFun(data.version)
                // console.log(linkType)
                if(linkType == '' || linkType == 'login'){
                    linkType = 'dashboard'
                    this.$router.push({path:'/dashboard'})
                    // if(data.version == '0'){
                    //     document.title = 'inHealth-dashboard'
                    // }
                    // if(data.version == '1'){
                    //     document.title = '工业照明-设备概览'
                    // }
                }
                // console.log(linkType)
                this.$store.commit('ROUTERSTRFUN',{
                    routerStr:'/'+linkType
                })
                if(linkType == 'login'||linkType == 'retrievePassword'){
                    this.headersShow = false
                }else{
                    this.headersShow = true
                }
                // if(this.version == '0'){
                //     document.title = 'inHealth-'+this.linkTypeData['/'+linkType]
                // }
                // if(this.version == '1'){
                //     document.title = '工业照明-'+this.linkTypeData['/'+linkType]
                // }
            }else{
                if(linkType != 'retrievePassword'){
                    storage.setItem('userData','')
                    this.$store.commit('ROUTERSTRFUN',{
                      routerStr:'/login',
                    })
                    this.$router.push({path:'/login'});
                }
            }
            this.versionFun(this.version)
            this.$router.beforeEach((to, from, next) => {
                console.log(to.path,'--------')
                if(to.path == '/login'||to.path == '/retrievePassword'){
                    this.headersShow = false
                }else{
                    this.headersShow = true
                }
                // console.log(this.headersShow)
                // console.log(linkTypeData,linkTypeData[to.path],to.path,'------sdsdd--')
                if(this.version == '0'){
                    document.title = 'inHealth-'+this.linkTypeData[to.path]
                }
                if(this.version == '1'){
                    document.title = '工业照明-'+this.linkTypeData[to.path]
                }
                this.$store.commit('ROUTERSTRFUN',{
                    routerStr:to.path
                })

                next();
            })
            this.linkTypeData = {
                '/login':this.$t("App.login.text6"),
                '/retrievePassword':this.$t("App.retrievePassword.text1"),
                '/dashboard':this.$t("App.sideBar.text1"),
                '/room':this.$t("App.sideBar.text2"),
                '/classroomLights':this.$t("App.sideBar.text3"),
                '/blackboardLights':this.$t("App.sideBar.text4"),
                '/switchPanel':this.$t("App.sideBar.text5"),
                '/curtain':this.$t("App.sideBar.text6"),
                '/lights':this.$t("App.sideBar.text7"),
                '/circadianLights':this.$t("App.sideBar.text8"),
                '/circadianLightsPlan':this.$t("App.siteManagement.text3"),
                '/sensor':this.$t("App.sideBar.text15"),
                '/uvLight':this.$t("App.sideBar.text18"),
                '/service':this.$t("App.sideBar.text11"),
                '/maintenanceStaff':this.$t("App.service.text3"),
                '/pushSetting':this.$t("App.service.text2"),
                '/alarmProfile':this.$t("App.service.text4"),
                '/airPurifiers':this.$t("App.sideBar.text9"),
                '/gateway':this.$t("App.sideBar.text10"),
                '/activityHistory':this.$t("App.sideBar.text12"),
                '/room-light':this.$t("App.sideBar.text2"),
                '/userManagement':this.$t("App.sideBar.text13"),
                '/siteManagement':this.$t("App.sideBar.text14"),
            };
            
            // this.loadJS('https://maps.googleapis.com/maps/api/js?key=AIzaSyD_FHQc9qTI5SPvTBV0SQ-aPS2HJHm8H9U&language=en',function(){})
            // this.loadJS('./src/store/infobox.js',function(){})
            // this.loadJS('./src/store/richmarker.js',function(){})
        },
        mounted(){
            let this_ = this;
            let width = document.body.offsetWidth;
            if(width >= 1920){
                $('html').css({'font-size':'95.01%'})
                this.$store.commit('REMRATIOFUN',{
                    remRatio:0.9501*16,
                })
            }else if(width >= 1200){
                $('html').css({'font-size':width*62.5/1200+'%'})
                this.$store.commit('REMRATIOFUN',{
                    remRatio:width*62.5/1200/100*16,
                })
            }else{
                $('html').css({'font-size':'62.5%'})
                this.$store.commit('REMRATIOFUN',{
                    remRatio:0.625*16,
                })
            }
            window.onresize = function(){
                width = document.body.offsetWidth;
                console.log(width)
                if(width >= 1920){
                    $('html').css({'font-size':'95.01%'})
                    this_.$store.commit('REMRATIOFUN',{
                        remRatio:0.9501*16,
                    })
                }else if(width >= 1200){
                    $('html').css({'font-size':width*62.5/1200+'%'})
                    this_.$store.commit('REMRATIOFUN',{
                        remRatio:width*62.5/1200/100*16,
                    })
                }else{
                    $('html').css({'font-size':'62.5%'})
                    this_.$store.commit('REMRATIOFUN',{
                        remRatio:0.625*16,
                    })
                }
                this_.$store.commit('UPDATEREMRATIOFUN',{
                    updateRemRatio:this_.updateRemRatio+1,
                })
                
            }
            // console.log(this.i18nArr[this.version],this.version,this.i18nArr)
            // this.$i18n.locale = this.i18nArr[this.version];
        },
        methods:{
            versionFun(val){
                // this.$store.commit('VERSION',{
                //     version:val,
                // }){
                let this_ = this;
                if(val == '1'){
                    this.$i18n.locale = 'zh-CN'
                    if(!this.webapiAmap){
                        this.loadJS('https://webapi.amap.com/maps?v=1.4.6&key=192cfd61cc0fbe8c2cf8d5c314f43bb3&plugin=AMap.MarkerClusterer,AMap.ToolBar,AMap.Autocomplete,AMap.PlaceSearch,AMap.Geocoder,AMap.Geolocation',function(){
                            this_.loadJS('https://webapi.amap.com/ui/1.0/main.js?v=1.0.11',function(){})
                            this_.$store.commit('WEBAPIAMAP',{
                                webapiAmap:true
                            })
                        })
                    }
                }
                if(val == '0'){
                    this.$i18n.locale = 'en-US'
                  if(!this.isGoogleapis){
                    this.loadJS('https://maps.googleapis.com/maps/api/js?key=AIzaSyBu9LweyAtYu26iTWwzxozPEco1xosnIoI&language=en',function(){
                        this_.loadJS('./js/infobox.js',function(){
                            this_.loadJS('./js/richmarker.js',function(){
                                this_.$store.commit('ISGOOGLEAPIS',{
                                    isGoogleapis:true
                                })
                            })
                        })
                    })
                  }
                }
            },
            loadJS( url, callback ){
                let script = document.createElement('script'),
                fn = callback || function(){};
                script.type = 'text/javascript';
                //IE
                if(script.readyState){
                  script.onreadystatechange = function(){
                    if( script.readyState == 'loaded' || script.readyState == 'complete' ){
                      script.onreadystatechange = null;
                      fn();
                    }
                  };
                }else{
                  //其他浏览器
                  script.onload = function(){
                    fn();
                  };
                }
                script.src = url;
                document.getElementsByTagName('head')[0].appendChild(script);
            }
        }
    }
</script>

<style type="text/css" lang="less">
    @font-face {
        font-family: 'PingFangSC-Regular';
        src: url('./style/font-pf/PingFangRegular.ttf');
        src:
          url('./style/font-pf/PingFangRegular.eot?#font-spider') format('embedded-opentype'),
          url('./style/font-pf/PingFangRegular.woff') format('woff'),
          url('./style/font-pf/PingFangRegular.ttf') format('truetype'),
          url('./style/font-pf/PingFangRegular.svg') format('svg');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'PingFang-SC-Heavy';
        src: url('./style/font-pf/PingFangHeavy.eot');
        src:
          url('./style/font-pf/PingFangHeavy.eot?#font-spider') format('embedded-opentype'),
          url('./style/font-pf/PingFangHeavy.woff') format('woff'),
          url('./style/font-pf/PingFangHeavy.ttf') format('truetype'),
          url('./style/font-pf/PingFangHeavy.svg') format('svg');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'AlibabaPuHuiTiR';
        src: url('./style/font-al/Alibaba-PuHuiTi-Regular.eot');
        src:
          url('./style/font-al/Alibaba-PuHuiTi-Regular.eot?#font-spider') format('embedded-opentype'),
          url('./style/font-al/Alibaba-PuHuiTi-Regular.woff') format('woff'),
          url('./style/font-al/Alibaba-PuHuiTi-Regular.ttf') format('truetype'),
          url('./style/font-al/Alibaba-PuHuiTi-Regular.svg') format('svg');
        font-weight: normal;
        font-style: normal;
    }
    @font-face {
        font-family: 'AlibabaPuHuiTiH';
        src: url('./style/font-al/Alibaba-PuHuiTi-Heavy.ttf');
        src:
          url('./style/font-al/Alibaba-PuHuiTi-Heavy.eot?#font-spider') format('embedded-opentype'),
          url('./style/font-al/Alibaba-PuHuiTi-Heavy.woff') format('woff'),
          url('./style/font-al/Alibaba-PuHuiTi-Heavy.ttf') format('truetype'),
          url('./style/font-al/Alibaba-PuHuiTi-Heavy.svg') format('svg');
        font-weight: normal;
        font-style: normal;
    }
    @font-face {
        font-family: 'AlibabaPuHuiTiB';
        src: url('./style/font-al/Alibaba-PuHuiTi-Bold.ttf');
        src:
          url('./style/font-al/Alibaba-PuHuiTi-Bold.eot?#font-spider') format('embedded-opentype'),
          url('./style/font-al/Alibaba-PuHuiTi-Bold.woff') format('woff'),
          url('./style/font-al/Alibaba-PuHuiTi-Bold.ttf') format('truetype'),
          url('./style/font-al/Alibaba-PuHuiTi-Bold.svg') format('svg');
        font-weight: normal;
        font-style: normal;
    }
    @font-face {
        font-family: 'AlibabaPuHuiTiL';
        src: url('./style/font-al/Alibaba-PuHuiTi-Light.ttf');
        src:
          url('./style/font-al/Alibaba-PuHuiTi-Light.eot?#font-spider') format('embedded-opentype'),
          url('./style/font-al/Alibaba-PuHuiTi-Light.woff') format('woff'),
          url('./style/font-al/Alibaba-PuHuiTi-Light.ttf') format('truetype'),
          url('./style/font-al/Alibaba-PuHuiTi-Light.svg') format('svg');
        font-weight: normal;
        font-style: normal;
    }
    @font-face {
        font-family: 'AlibabaPuHuiTiM';
        src: url('./style/font-al/Alibaba-PuHuiTi-Medium.ttf');
        src:
          url('./style/font-al/Alibaba-PuHuiTi-Medium.eot?#font-spider') format('embedded-opentype'),
          url('./style/font-al/Alibaba-PuHuiTi-Medium.woff') format('woff'),
          url('./style/font-al/Alibaba-PuHuiTi-Medium.ttf') format('truetype'),
          url('./style/font-al/Alibaba-PuHuiTi-Medium.svg') format('svg');
        font-weight: normal;
        font-style: normal;
    }
    // @font-face {
    //     font-family: 'bodoni-MT';
    //     src: url('./style/bodoniMT/bodoniMT.ttf');
    // }

    html,body,p,h1,h2,h3,h4,h5,ul,li{
        margin: 0px;
        padding: 0px;
    }
    html,body,#app{
          height: 100%;
          width:100%;
    }
    li{
        list-style:none;/*li去点*/
        box-sizing: border-box;
    }
    a{
        text-decoration: none;
        box-sizing: border-box;
    }
    i{
        font-style: inherit;
    }
    input{
        padding:0;
        outline-style: none;
        box-sizing: border-box;
    }
    div{
        box-sizing: border-box; //border、padding并入宽度。
    }
      /*滚动条样式*/
    .el-table__body-wrapper::-webkit-scrollbar {/*滚动条整体样式*/
        width: 3px;     /*高宽分别对应横竖滚动条的尺寸*/
        height: 5px;
    }
    .el-table__body-wrapper::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
        border-radius: 3px;
        background: #DAE6E0;
    }
    .el-table__body-wrapper::-webkit-scrollbar-track {/*滚动条里面轨道*/
        background: #F6F8F7;
    }
    .el-table{
        th>.cell,td>.cell{
            padding: 0;
        }
        .el-table__body-wrapper{
            width: calc(100% - 8px);
            margin-right: 8px;
        }
    }
    .el-time-panel{
        .el-time-spinner__list::after, .el-time-spinner__list::before{
            height:70px;
        }
    }

    .scrollbar_style{
        margin-right: 8px;
        overflow: auto;
    }
      /*.scrollbar_style::-webkit-scrollbar-button{
         width: 10px;
         height: 10px;
      }*/
    .scrollbar_style::-webkit-scrollbar {/*滚动条整体样式*/
        width: 3px;     /*高宽分别对应横竖滚动条的尺寸*/
        height: 5px;
    }
    .scrollbar_style::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
        border-radius: 3px;
        background: #DAE6E0;
    }
    .scrollbar_style::-webkit-scrollbar-track {/*滚动条里面轨道*/
        background: #F6F8F7;
    }
    #app{
        // margin: 0 auto;
        min-width: 1200px;
        // max-width: 2400px;
        input::-webkit-input-placeholder {
            font-family: AlibabaPuHuiTiR;
            /* placeholder颜色  */
            // color: #aab2bd;
            /* placeholder字体大小  */
            // font-size: 19px;
            /* placeholder位置  */
            // text-align: right;
        }
        .el-checkbox__label,.el-table__empty-text,.btn{
            font-family: AlibabaPuHuiTiR;
        }
        >.scrollbar_style{
            // width: calc(100% - 8px);
            width: calc(100%);
            height: 100%;
            &.padding{
                padding-top: 4.2rem;
            }
        }
    }
    .cn{
        .el-checkbox__input{
            &.is-checked .el-checkbox__inner{
                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                border-color: rgba(0,0,0,0);
            }
            &.is-indeterminate .el-checkbox__inner{
                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                border-color: rgba(0,0,0,0);
            }

        }
    }
    .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{
        color: initial;
        background-color: #f5f7fa;
    }
    .el-dropdown-menu{
        max-height: 360px;
        .el-dropdown-menu__item{
            &.select{
                color: #409eff;
                font-weight: 700;
            }
        }
    }
    /*room-light*/
    .el-slider,.btn{
        .el-loading-mask{
            background-color:rgba(255,255,255,0.4);
            .el-loading-spinner{
                margin-top: 0;
                top: 0;
                height: 100%;
            }
            .circular{
                width: initial;height: 100%;width: 100%;
            }
        }
        position: relative;
    }
    /*Lights Circadian lights 页面*/
    .el-popover.brightness_slider{
        width: 16rem;height: 2.75rem;line-height: 2.75rem;
        padding: 0;
        .slider_box{
            display: flex;
            justify-content: space-between;
            &.cn{
                .el-slider__runway{
                    .el-slider__bar{
                        background: linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                    .el-slider__button{
                        background: linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                }
            }

            .text{
                margin-right: 0.5rem;
                font-size:1rem;
                font-family:AlibabaPuHuiTiB;
                color:rgba(51,51,51,1);
            }
        }
        .el-slider__runway{
            width: 11rem;height: 0.8rem;
            margin: 1rem 0 0 1rem;
            border-radius:0.8rem;
            .el-slider__bar{
                margin-top: 0.15rem;
                height: 0.5rem;
                background-color: rgba(5, 207, 171, 1);
            }
            .el-slider__button-wrapper{
                top: -1rem;
                width: 2.75rem;height: 2.75rem;
                .el-slider__button{
                    width: 0.8rem;height: 0.8rem;
                    border: 0.2rem solid #FFFFFF;
                    background-color: rgba(5, 207, 171, 1);
                }
            }
        }
    }
    .el-popover.color_slider{
        width: 16rem;height: 2.75rem;line-height: 2.75rem;
        padding: 0;
        .slider_box{
            display: flex;
            justify-content: space-between;
            .text{
                margin-right: 0.5rem;
                font-size:1rem;
                font-family:AlibabaPuHuiTiB;
                color:rgba(51,51,51,1);
            }
        }
        .el-slider__runway{
            width: 11rem;height: 0.8rem;
            margin: 1rem 0 0 1rem;
            border-radius:0.8rem;
            .el-slider__bar{
                margin-top: 0.15rem;
                height: 0.5rem;
                background-color: rgba(255, 190, 0, 1);
            }
            .el-slider__button-wrapper{
                top: -1rem;
                width: 2.75rem;height: 2.75rem;
                .el-slider__button{
                    width: 0.8rem;height: 0.8rem;
                    border: 0.2rem solid #FFFFFF;
                    background-color: rgba(255, 190, 0, 1);
                }
            }
        }
    }
    /*Lights Circadian lights 页面*/
    .el-popover.light_dg_slider{
        width: 20rem;
        padding: 0;
        .slider_box{
            p{
                display: flex;
                justify-content: space-between;
                height: 2.75rem;line-height: 2.75rem;
                .span{
                    margin-left: 0.8rem;
                    font-size:1rem;
                    font-family:AlibabaPuHuiTiB;
                    color:rgba(51,51,51,1);
                }
            }
            .text{
                margin-left: 1rem;
                margin-right: 1rem;
                font-size:1rem;
                font-family:AlibabaPuHuiTiR;
                color:rgba(5,207,171,1);
            }
        }
        .el-slider__runway{
            width: 11rem;height: 0.8rem;
            margin: 1rem 0 0 1rem;
            border-radius:0.8rem;
            .el-slider__bar{
                margin-top: 0.15rem;
                height: 0.5rem;
                background-color: rgba(5, 207, 171, 1);
            }
            .el-slider__button-wrapper{
                top: -1rem;
                width: 2.75rem;height: 2.75rem;
                .el-slider__button{
                    width: 0.8rem;height: 0.8rem;
                    border: 0.2rem solid #FFFFFF;
                    background-color: rgba(5, 207, 171, 1);
                }
            }
        }
    }
</style>
